import { isCordova } from 'utils/platform';

/**
 * Helper function to add session token to request headers or set credentials to include session cookies
 * @param requestInit
 * @param sessionToken
 */
export const requestOptionsWithSessionToken = (
  requestInit: RequestInit,
  sessionToken: string | undefined,
): RequestInit => {
  if (sessionToken && isCordova()) {
    const headers = requestInit.headers || {};
    headers['Authorization'] = `Bearer ${sessionToken}`;
    return { ...requestInit, headers };
  }

  return {
    ...requestInit,
    credentials: 'include',
  };
};
